export default __webpack_public_path__ + "static/media/Ayomide Ibosiola —  Snr. Technical Recruiter.9c895997.pdf";